/**
 * @generated SignedSource<<2ff2058bbfcc197286f537e0a9603dff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storyStyleLargeLayoutQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly images?: ReadonlyArray<{
      readonly wide_landscape: {
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly " $fragmentType": "storyStyleLargeLayoutQueueItemsEdge";
}>;
export type storyStyleLargeLayoutQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: storyStyleLargeLayoutQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyStyleLargeLayoutQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "storyStyleLargeLayoutQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "type": {
                      "exclude": null
                    }
                  }
                }
              ],
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                {
                  "alias": "wide_landscape",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "filter",
                      "value": {
                        "style": "wide_landscape"
                      }
                    }
                  ],
                  "concreteType": "ImageStyle",
                  "kind": "LinkedField",
                  "name": "style",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                }
              ],
              "storageKey": "images(filter:{\"type\":{\"exclude\":null}})"
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "ff7d1585c375002ef855252e88ca9f05";

export default node;
